import React, { FC } from "react"

import { Button, Modal, ModalProps, Stack, TextInput } from "@mantine/core"

import usePasswordRecovery from "./usePasswordRecovery"
import { useLanguage } from "../../../../contexts/language-context"

export const ForgotPasswordModal: FC<ModalProps> = ({ opened, onClose }) => {
    const { form, sendRecovery, loading } = usePasswordRecovery(onClose)
    const { L } = useLanguage()

    return (
        <Modal opened={opened} onClose={onClose} title={L("Send password recovery email")}>
            <form onSubmit={form.onSubmit(sendRecovery)}>
                <Stack spacing="xl">
                    <TextInput
                        placeholder={L("Email address")}
                        label={L("Email address")}
                        {...form.getInputProps("email")}
                    />
                    <Button type="submit" loading={loading}>
                        {L("Send")}
                    </Button>
                </Stack>
            </form>
        </Modal>
    )
}
